import { PageId } from 'constants/pages'

export const enum PageIdWoofzNdd70 {
  SUBSCRIPTIONS_NDD_70 = PageId.SUBSCRIPTIONS_NDD_70,
  CHAT_UPSELL_NDD_70 = PageId.CHAT_UPSELL_NDD_70,
  UPSELL_NDD_70 = PageId.UPSELL_NDD_70,
  DOWNLOAD_NDD_70 = PageId.DOWNLOAD_NDD_70,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
